import { render, staticRenderFns } from "./modalVideo.vue?vue&type=template&id=5ec4106c"
import script from "./modalVideo.vue?vue&type=script&lang=js"
export * from "./modalVideo.vue?vue&type=script&lang=js"
import style0 from "./modalVideo.vue?vue&type=style&index=0&id=5ec4106c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports